import { render } from "./ArticleClassification.vue?vue&type=template&id=f8222da6"
import script from "./ArticleClassification.vue?vue&type=script&lang=js"
export * from "./ArticleClassification.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__